// JavaScript code for acf_blocks/horizontal-vertical-accordions-block component
(($) => {

     "use strict";
     if ($('.acf-blocks-horizontal-vertical-accordions-block').length === 0) {
          return;
     }
     console.log("acf_blocks/horizontal-vertical-accordions-block scripts loaded...");

     $('.acf-blocks-horizontal-vertical-accordions-block').on('click', '.accordion-title', function () {
          const $accordion = $(this).parent('.accordion');
          if ($accordion.hasClass('active')) {
               return;
          }

          $accordion.toggleClass('active').siblings('.accordion').removeClass('active');
          $("html,body").scrollTop($accordion.offset().top - 175);
     });

})(jQuery);